import { render, staticRenderFns } from "./pushMessageList.vue?vue&type=template&id=66bdaab4&scoped=true&"
import script from "./pushMessageList.vue?vue&type=script&lang=js&"
export * from "./pushMessageList.vue?vue&type=script&lang=js&"
import style0 from "./pushMessageList.vue?vue&type=style&index=0&id=66bdaab4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bdaab4",
  null
  
)

export default component.exports